import React from "react";
import { Link } from "react-router-dom";
import { Box, Container, Typography, Button, Grid, Paper } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2C3E50",
    },
    secondary: {
      main: "#3498DB",
    },
    background: {
      default: "#F5F7FA",
    },
    text: {
      primary: "#34495E",
    },
  },
});

export default function About() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ backgroundColor: "background.default", py: 8 }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Paper elevation={3}>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/AboutImage.jpg`}
                  alt="Zimbabwe Real Estate"
                  style={{ width: "100%", height: "auto", borderRadius: "4px" }}
                />
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h3" color="primary" gutterBottom>
                About Dhorobha
              </Typography>
              <Typography variant="body1" paragraph>
                Dhorobha is Zimbabwe&apos;s premier real estate platform,
                connecting buyers, sellers, and investors with exceptional
                properties across the nation. Our mission is to revolutionize
                the Zimbabwean real estate market by providing transparent,
                efficient, and user-friendly services.
              </Typography>
              <Typography variant="body1" paragraph>
                With a deep understanding of Zimbabwe&apos;s unique real estate
                landscape, we offer:
              </Typography>
              <ul>
                <Typography component="li" variant="body1">
                  Extensive listings in major cities like Harare and Bulawayo
                </Typography>
                <Typography component="li" variant="body1">
                  Expert insights into emerging property hotspots
                </Typography>
                <Typography component="li" variant="body1">
                  Guidance on navigating Zimbabwe&apos;s property laws and
                  regulations
                </Typography>
                <Typography component="li" variant="body1">
                  Connections to trusted local real estate professionals
                </Typography>
              </ul>
              <Box mt={4}>
                <Button
                  component={Link}
                  to="/contact"
                  variant="contained"
                  color="secondary"
                  size="large"
                >
                  Contact Us
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
